<template>
  <div class="upload_box">
  <div class="upload_contain1" @dragover="fileDragover" @drop="fileDrop" v-if="state==0">
    <div class="nofilebox">
      <label for="fileInput" class="labelbox"><img :src="require('@/assets/upload-icon.png')" class="upload_img"/>
        <div class="upload_text">点击或拖放上传应用</div>
        <div class="upload_text2">请上传 APK 文件</div>
        <div class="upload_tishi">上传后24小时内有效</div>
      </label>
      <input type="file" id="fileInput" @change="chooseUploadFile" style="background: red;display: none">
    </div>
    <div class="msgbox" v-show="isshowmsg==true">{{ msgtext }}</div>
  </div>
  <div class="upload_contain2" v-if="state==1">
    <div class="file-name">{{ fileName }}</div>
    <div class="progress_box">
      <div class="progress_now" :style="{'width':progress+'%' }"></div>
    </div>
    <div class="progress_text">正在上传中…<span class="progress_num">{{ progress }}%</span></div>
  </div>
  <div class="upload_contain" v-if="state==2">
    <img :src="require('@/assets/apk.png')" class="apk_logo"/>
    <div class="file-name">{{ fileName }}</div>
    <label for="fileInputagian">
      <div class="upload_again">重新上传</div>
    </label>
    <input type="file" id="fileInputagian" @change="chooseUploadFile" style="background: red;display: none">
    <div class="upload_error">{{ errortext }}</div>
    <div class="msgbox" v-show="isshowmsg==true">{{ msgtext }}</div>
  </div>
  <div class="upload_contain" v-if="state==3">
    <div class="tv_header">请在电视端【<span class="progress_num">欢视助手</span>】>【<span
      class="progress_num">应用安装助手</span>】中输入口令即可下载安装
    </div>
    <div class="apk_name">{{ fileName }}</div>
    <div class="codebox">
      <div class="code_item" v-for="(item,index) in code">{{ item }}</div>
    </div>
    <div class="code_text">请牢记口令，并尽快使用</div>
    <div class="code_text2">请在 {{ codetime }} 前使用，之后会被删除</div>
    <div class="resumebtn" @click="goback">继续上传</div>
  </div>
               <div class="agreement_box">
                 <a href="https://ottepg-moss.cedock.com/tvhelper/agreement/useragreement.html" target="_blank">用户协议</a>｜<a href="https://ottepg-moss.cedock.com/tvhelper/agreement/privacyagreement.html" target="_blank">隐私政策</a>
               </div>
            <div class="apkload_button" @click="downloadapk"  v-if="isMobile">下载欢视助手TV版</div>
            <div style="height: 30px;width: 320px;" v-if="isMobile"></div>
  </div>

</template>

<script>
import axios from 'axios'
import https from "../https";
import SparkMD5 from "spark-md5";
import {pageServer} from "../util"

const chunkSize = 10 * 1024 * 1024;//定义分片的大小 暂定为5M，方便测试
export default {
  name: "upload",
  data() {
    return {

      fileName: '',
      progress: 0,
      code: [],
      state: 0,//0-未上传 1-上传中 2- 上传失败 3-上传成功口令
      MAX_FILE_SIZE: 10 * 1024 * 1024,  //250 * 1024 * 1024
      file: null,
      chunks: [],
      uploadPercentage: 0,
      identifiertime: '',
      uploading: false,
      sharedsize: chunkSize, //5M 分片大小
      errortext: '',
      codetime: '',
      isshowmsg: false,//显示弹窗
      msgtext: '',

      chunkNumber: 0, // 当前分片数
      uploadedChunks: [], // 上传完成的分片数组
      apkfilesize: 0,
      intervalId: null,
      isMobile:false

    }
  },
  mounted() {
    let userAgent = navigator.userAgent;
    this.isMobile = /mobile|android/i.test(userAgent);
  },
  methods: {


    // 点击上传
    chooseUploadFile(event) {
      let file = event.target.files[0];
      if (!file) return
      if (file.size > this.MAX_FILE_SIZE) {
        this.msgtext = '文件大小不能超过10M';
        this.showmsg();
        return
      }
      this.apkfilesize = file.size;
      this.fileName = file.name;
      this.identifiertime = file.size + "huan" + new Date().getTime();

      this.fenpian(file);
      // 清空，防止上传后再上传没有反应
      event.target.value = ''
    },


    // 拖拽上传
    fileDragover(e) {
      e.preventDefault()
    },
    fileDrop(e) {
      e.preventDefault()
      let file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
      if (!file) return
      if (file.size > this.MAX_FILE_SIZE) {
        this.msgtext = '文件大小不能超过10M';
        this.showmsg();
        return
      }

      this.fileName = file.name;
      this.identifiertime = file.size + "huan" + new Date().getTime();

      this.fenpian(file);

    },

    fenpian(file) {
      clearInterval(this.intervalId);
      this.chunks = [];
      const chunkSize = this.sharedsize;
      let filename=file.name;
      let filePathname1=filename.substring(filename.length-4);
      let filePathname2=filename.substring(filename.length-6);
      let filePathname3=filename.substring(filename.length-8);
      let filePathname4=filename.substring(filename.length-10);
      if((filePathname1=='.apk')||(filePathname2=='.apk.1')||(filePathname3=='.apk.1.1')||(filePathname4=='.apk.1.1.1')){
      }else{
        this.msgtext = '请上传apk文件';
        this.showmsg();
        return;
      }
     /* let sk = `${file.name.split('.')}`;
      sk = sk.split(',');
      let fileType = sk[sk.length - 1] // 文件类型后缀
      if (fileType != 'apk') {
        this.msgtext = '请上传apk文件';
        this.showmsg();
        return;
      }*/

      let totalChunks = Math.ceil(file.size / chunkSize);
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);
        this.chunks.push(chunk);
      }

      this.chunkNumber = 0;
      this.uploadChunks(this.chunks);


    },

    showmsg() {
      this.isshowmsg = true;
      setTimeout(() => {
        this.isshowmsg = false;
      }, 2000)
    },


    /*   async uploadChunks(fileChunks) {
         // 确保文件分片已准备好后再上传
         let index = 0;
         this.state = 1;
         const uploadUrl = pageServer + '/api/v1/helper/wechat/apk/upload/h5Part'; // 上传文件的URL
         // 每次上传分片后获取已上传的分片索引
         //  let uploadedChunks = [];
         for (let i = 0; i < fileChunks.length; i++) {
           let formdata = new FormData();
           formdata.append('pluginFile', fileChunks[i])
           formdata.append('apkname', this.fileName)
           formdata.append('fileName', this.fileName)
           formdata.append('index', Number(i))
           formdata.append('identifier', this.identifiertime)
           formdata.append('token', '')
           await axios.post(uploadUrl, formdata, {
             headers: {
               'Content-Type': 'multipart/form-data',
               /!* 'Content-Type': 'application/octet-stream'*!/ // 设置请求头为multipart/form-data，以支持文件上传
             },
             onUploadProgress: (progressEvent) => {
               // 计算上传进度
               const percentCompleted = Math.round(((i * progressEvent.total + progressEvent.loaded) / (fileChunks.length * progressEvent.total)) * 100);
               if (percentCompleted < 100) {
                 this.progress = percentCompleted;
               } else {
                 this.progress = 99;
               }

             }
           });
         }

         //合并

         ///   console.log('所有文件切片已上传完成,去合并');  //所有切片上传完成后，你可以提示用户文件上传完成。你还可以在这里调用其他处理整个文件上传完成的函数。如合并文件，清理内存等。

         const mergurl = pageServer + '/api/v1/helper/wechat/apk/upload/h5Merge'; // 上传文件的URL
         axios.post(mergurl, {
           "param": {
             "fileName": this.fileName, "identifier": this.identifiertime, "token": ''
           }
         })
           .then((res) => {
             this.progress = 100;
             console.log("合并接口", res)
             if (res.data.code == 0) {
               this.state = 3;
               this.progress = 0;
               let sharecode = res.data.data.shareCode;
               this.codetime = res.data.data.expirationDate;
               this.code = sharecode.split("");
             } else {
               this.state = 2;
               this.progress = 0;
               this.errortext = res.data.message;
             }

           })


       },
   */

    uploadChunks(fileChunks) {
      // this.uploading = true;

      this.state = 1;
      this.uploadedChunks = [];
      let prosszu = [];
      let completedChunks = 0;
      const uploadUrl = pageServer + '/api/v1/helper/wechat/apk/upload/h5Part'; // 上传文件的URL
      for (let i = 0; i < fileChunks.length; i++) {
        const formdata = new FormData();
        prosszu[i] = 0;
        formdata.append('pluginFile', fileChunks[i])
        formdata.append('apkname', this.fileName)
        formdata.append('fileName', this.fileName)
        formdata.append('index', Number(i))
        formdata.append('identifier', this.identifiertime)
        formdata.append('token', '')

        const xhr = new XMLHttpRequest();

        let fen = 100 / fileChunks.length;
        fen = fen.toFixed(2);
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {

            const chunkProgress = (event.loaded / event.total) * 100;
            prosszu[i] = chunkProgress;
            let totals = 0;
            for (let j = 0; j < fileChunks.length; j++) {
              totals += prosszu[j] * (1 / fileChunks.length);
            }
            totals = totals * 0.6;
            this.progress = totals.toFixed(0);
            // console.log(this.progress)
            clearInterval(this.intervalId);
            if (this.progress >= 60) {
              //this.progress=Number(this.progress)+1;
              this.putofftime();

            }


          }
        };
        xhr.open('POST', uploadUrl, true);


        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            //  console.log("上传完成一个",xhr);
            this.uploadedChunks.push(i);
            if (this.uploadedChunks.length === fileChunks.length) {
              // console.log("所有文件上传完成")
              const mergurl = pageServer + '/api/v1/helper/wechat/apk/upload/h5Merge'; // 上传文件的URL
              setTimeout(() => {
                console.log("开始合并")
                axios.post(mergurl, {
                  "param": {
                    "fileName": this.fileName, "identifier": this.identifiertime, "token": ''
                  }
                })
                  .then((res) => {
                    this.progress = 100;
                    clearInterval(this.intervalId)
                    //  console.log("合并接口", res)
                    setTimeout(() => {
                      if (res.data.code == 0) {
                        this.state = 3;
                        this.progress = 0;
                        let sharecode = res.data.data.shareCode;
                        this.codetime = res.data.data.expirationDate;
                        this.code = sharecode.split("");
                      } else {
                        this.state = 2;
                        this.progress = 0;
                        this.errortext = res.data.message;
                      }


                    }, 1000)


                  })
              }, 500);

            } else {
              //console.log("************")
            }
          }
          /*      this.uploadedChunks.push(i);
                if (this.uploadedChunks.length === fileChunks.length) {
                  // 所有分片已上传完成
                  console.log("所有分片上传完了")
                  const mergurl = pageServer + '/api/v1/helper/wechat/apk/upload/h5Merge'; // 上传文件的URL
                  axios.post(mergurl, {
                    "param": {
                      "fileName": this.fileName, "identifier": this.identifiertime, "token": ''
                    }
                  })
                    .then((res) => {
                      this.progress = 100;
                      clearInterval(this.intervalId)
                    //  console.log("合并接口", res)
                      setTimeout(()=>{
                        if (res.data.code == 0) {
                          this.state = 3;
                          this.progress = 0;
                          let sharecode = res.data.data.shareCode;
                          this.codetime = res.data.data.expirationDate;
                          this.code = sharecode.split("");
                        }
                        else {
                          this.state = 2;
                          this.progress = 0;
                          this.errortext = res.data.message;
                        }


                      },1000)


                    })



                }*/
        };

        xhr.send(formdata);
        completedChunks++;

      }
    },

    //延迟上传进度

    putofftime() {
      this.intervalId = setInterval(() => {
        if (this.progress < 99) {
          this.progress = Number(this.progress) + 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1500);


    },


    //继续上传
    goback() {
      this.state = 0;
    },
    downloadapk(){
      const url='https://dl-appstore.huan.tv/project/ott/tvhelper/TVhelper_general_1.0.0_20231023174019_release.apk';
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // 可选，设置下载文件的名称
      link.click();
    },
  }
}
</script>

<style scoped>
.upload_box{
  width: 100%;
  height: 100%;
   display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;

}
.upload_contain1 {
  width: 90%;
  margin: 0% 5%;
  padding:6% 0%;
  max-width: 1398px;
  /*  min-width: 1198px;*/
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
  border-radius: 20px;
  border: 1px dashed #0091FF;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin-top: 8%;
  margin-bottom: 20px;


}

.upload_contain2 {
  width: 90%;
  margin: 0% 5%;
  /*  padding: 14% 0%;*/
  max-width: 1398px;
  /*  min-width: 1198px;*/
  height: 70%;
  background: #FFFFFF;
  box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
  border-radius: 20px;
  /* border: 1px solid #0091FF;*/
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin-top: 8%;
  margin-bottom: 20px;
}

.upload_contain {
  width: 90%;
  margin: 0% 5%;
  max-width: 1398px;
  padding: 2% 0px;
  background: #FFFFFF;
  box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
  border-radius: 20px;
  border: 1px solid #0091FF;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin-top: 8%;
  margin-bottom: 20px;
}

.nofilebox {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}


.labelbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.labelbox:hover {
  cursor: pointer;
}

.upload_img {
  width: 160px;
  height: auto;
}

.upload_text {
  width: 100%;
  text-align: center;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1A3060;
  line-height: 60px;
  margin-top: 10px;;
}

.upload_text2 {
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1A3060;
  line-height: 60px;
  margin-top: 10px;

}

.upload_tishi {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: red;
  line-height: 30px;

}


/*****弹窗提示*****/
.msgbox {
  padding: 10px 40px;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  max-width: 60%;
  font-size: 24px;
  color: #ffffff;
  border-radius: 10px;
}

/*******上传中********/
.file-name {
  width: 90%;
  padding: 0 5%;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1A3060;
  line-height: 60px;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.progress_box {
  width: 80%;
  margin: 70px 10% 50px 10%;
  height: 16px;
  background: #D8E0EB;
  border-radius: 8px;

}

.progress_now {
  height: 16px;
  background: linear-gradient(90deg, #0091FF 0%, #1457EF 100%);
  border-radius: 8px;
}

.progress_text {
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1A3060;
  margin-top: 20px;
}

.progress_num {
  color: #1457EF;
}

/******上传成功*******/
.tv_header {
  width: 80%;
  margin: 0 10%;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1A3060;
  line-height: 45px;
  margin-top: 50px;
}

.apk_name {
  width: 80%;
  margin: 20px 10%;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1A3060;
  white-space: normal;
  word-break: break-word;
}

.codebox {
  width: 80%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*  background: red;*/

}

.code_item {
  width: 20%;

  line-height: 200px;
  height: 200px;

  /*  height: 150px;
    line-height: 150px;*/
  text-align: center;
  font-size: 100px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #0E6BF5;
  background: #F0F6FF;
  border-radius: 8px;
  border: 1px solid #C0D9FF;
}

.code_text {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #E02020;
  line-height: 30px;
  margin-top: 20px;
}

.code_text2 {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939FB8;
  line-height: 22px;
  margin-top: 20px;
}

.resumebtn {
  width: 100%;
  font-size: 20px;

  text-align: center;
  line-height: 50px;
  color: #1457EF;
  margin-top: 50px;
  font-weight: 600;

}

.resumebtn:hover {
  cursor: pointer;
}

/******上传失败*****/
.apk_logo {
  width: 110px;
  height: auto;
  margin-bottom: 40px;
}

.upload_again {
  width: 300px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: linear-gradient(90deg, #0091FF 0%, #1457EF 100%);
  border-radius: 8px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 50px;
}

.upload_again:hover {
  cursor: pointer;
}

.upload_error {
  width: 80%;
  text-align: center;
  line-height: 50px;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #E02020;
  margin-top: 50px;

}


.agreement_box{
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #747F97;
  text-align: center;
  margin-bottom: 1%;
  margin-top: 3%;

}
.agreement_box a{
  color: #747F97;
  text-decoration: none;
}



@media screen and (max-width: 1000px) {
  .upload_contain {

    height: 65%;
    margin-top: 15%;
  }

  .upload_text {
    font-size: 26px;
  }

  .upload_text2 {
    font-size: 16px;
  }

  .upload_tishi {
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: red;
    line-height: 22px;
    margin-top: 5px;
  }

  .file-name {
    font-size: 24px;
    line-height: 50px;
  }

  .progress_text {
    font-size: 26px;
  }

  .tv_header {
    font-size: 24px;
    line-height: 40px;
    margin-top: 0px;
  }

  .apk_name {
    font-size: 20px;
  }

  .code_item {
    height: 80px;
    line-height: 80px;
    font-size: 60px;
  }

  .resumebtn {
    font-size: 16px;
  }

  .code_text {
    font-size: 20px;
    margin-top: 20px;
  }

  .upload_error {
    font-size: 18px;
    line-height: 30px;
    margin-top: 30px;

  }

  .apk_logo {
    width: 90px;
    height: auto;
    margin-bottom: 20px;
  }

  .upload_again {
    width: 200px;
    height: 60px;
    line-height: 60px;
    margin-top: 30px;
    font-size: 22px;
  }

  .resumebtn {
    margin-top: 10px;
  }

}


/*@media screen and (max-width: 750px){
  .upload_contain1{

    height: 65%;
    margin-top: 50% !important;
  }
}*/
@media screen and (max-width: 600px) {
  .upload_contain1 {
    width: 90%;
    margin: 0% 5%;
    padding: 10% 0%;
    /*  max-width: 1398px;*/
    /*  min-width: 1198px;*/
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
    border-radius: 20px;
    border: 1px dashed #0091FF;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin-top: 20%;
    margin-bottom: 20px;
  }

  .upload_contain {
    width: 90%;

    height: auto;
    padding: 4% 0px;
    background: #FFFFFF;
    box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
    border-radius: 20px;
    border: 1px solid #0091FF;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin-top: 32%;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 10px;
  }

  .upload_contain2 {
    width: 90%;
    margin: 0% 5%;
    /*  padding: 14% 0%;*/
    /*  min-width: 1198px;*/
    height: 55%;
    background: #FFFFFF;
    box-shadow: 0px 0px 35px 0px rgba(128, 149, 190, 0.15);
    border-radius: 20px;
    /* border: 1px solid #0091FF;*/
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin-top: 10%;
    margin-bottom: 20px;
  }

  .progress_box {
    width: 80%;
    margin: 30px 10% 30px 10%;
    height: 16px;
    background: #D8E0EB;
    border-radius: 8px;

  }

  /******上传成功*******/
  .tv_header {
    width: 90%;
    margin: 0 5%;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #1A3060;
    line-height: 35px;
    /*   margin-top: 20px;*/
  }

  .apk_name {
    font-size: 18px;
    width: 80%;
    margin: 5px 10%;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1A3060;
    white-space: normal;
    word-break: break-word;
  }

  .codebox {
    width: 90%;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*  background: red;*/

  }

  .code_item {
    width: 22%;

    line-height: 70px;
    height: 70px;

    /*  height: 150px;
      line-height: 150px;*/
    text-align: center;
    font-size: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #0E6BF5;
    background: #F0F6FF;
    border-radius: 8px;
    border: 1px solid #C0D9FF;
  }

  .code_text {
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E02020;
    line-height: 30px;
    margin-top: 10px;
  }

  .code_text2 {
    width: 90%;
    padding: 0px 5%;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #939FB8;
    line-height: 22px;
    margin-top: 20px;
  }
  .apkload_button{
    width: 90%;
    height: 40px;
    line-height: 40px;
    background-color: #1457EF;
    border-radius: 20px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    margin-top: 3%;

  }
  .apkload_button:hover {
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/upload.vue